module.exports = "<div class=\"text-center\">\n  <h1 class=\"error-code\">404</h1>\n  <h1>This page doesn't exist</h1>\n</div>"